import { render, staticRenderFns } from "./GuardiansAmendment.vue?vue&type=template&id=c537acf8"
import script from "./GuardiansAmendment.vue?vue&type=script&lang=js"
export * from "./GuardiansAmendment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports